// extracted by mini-css-extract-plugin
export var container = "styles-module__container___IMSgM";
export var content = "styles-module__content___O4ebJ";
export var details = "styles-module__details___ed__Y";
export var firstToReview = "styles-module__firstToReview___f2Lzu";
export var badgeHolder = "styles-module__badgeHolder___jq4mn";
export var link = "styles-module__link___XbU2s";
export var actions = "styles-module__actions___xVWZ5";
export var action = "styles-module__action___Z_pMe";
export var recording = "styles-module__recording___NCHln";